import React, {useEffect, useState} from 'react';
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import {Skeleton} from "../skeleton/Skeleton";
import {useDispatch, useSelector} from "react-redux";
import {refresh} from "../../redux/slice/apiSlice";


/*
* Todo api로딩이 안된건지 값 자체가 없는건지 구분해서 skeleton 을 보여줘야 한다.
* */
function UpdateInputBasic({target, required, listener, value, clicked, setClicked, style, auth, width, callBack, placeHolder}) {
    const [data, setData] =useState( value );
    const loading = useSelector(state => state.api.skeleton);
    const dispatch = useDispatch();
    useEffect(() => {
        setData(value);
    }, []);
    const [updatedData, setUpdatedData] =useState();

    const inputStyle = {
        backgroundColor: required && (!data || data.trim() === '') ? '#ffe5e5' : '',
        border: required && (!data || data.trim() ==='') ? '2px solid #e53939' : '',
        outline:'none',
        width : width ? width : '100%',
        // textColor : placeHolder ? placeHolder, 'b'
    };

    const basicStyle = {
        width : width ? width  : '100%',
        ...style
    }

    const keyDownHandler = async (event) => {
        if (event.keyCode === 13) {
            if(required && data.trim() === ''){
                alert("필수값입니다.")
                return;
            }
            console.log("updateInputBasic", {id: target.id, fieldName:target.fieldName, value : data})
            const response = await listener({id: target.id, fieldName:target.fieldName, value : data});
            if(response.status === 200){
                setUpdatedData(response.data)
                setClicked(false);
                if(callBack) {
                    callBack(data);
                }
                handleActiveToast({message: "데이터가 수정되었습니다"});
            }else if(response.status === 403){
                handleActiveError({message: "권한이 없습니다."});
            }else if(response.status === 409) {
                handleActiveError({message: "권한이 없습니다."});
            }else{
                handleActiveError({message: response.response.data.result});
            }

            dispatch(refresh(true))
        }

    }

    return (
        <>
        {!loading ?
            clicked && auth ?
                <input
                    type={"text"}
                    className={`basic-input focus`}
                    value={data}
                    onChange={(event) => setData(event.target.value)}
                    style={required ? inputStyle : basicStyle}
                    onKeyDown={keyDownHandler}
                    autoFocus={true}
                    onBlur={()=>{
                        setClicked(false);
                        setData(updatedData ? updatedData :value)
                    }}
                />
            :
                <span className={"edit-input"}>
                    {placeHolder ?? data}
                </span>
        :
            <Skeleton className={'w-full h-[30px]'}></Skeleton>
        }
        </>
    );
}

export default UpdateInputBasic;